import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DocumentService, DocumentSettingOutput } from 'core/http/project/document/document.service';
import { ownedError } from 'core/utils/owned-error';
import { Observable } from 'rxjs';

@Injectable()
export class SettingsResolver {
  constructor(private documentService: DocumentService) {}

  resolve(snapshot: ActivatedRouteSnapshot): Observable<DocumentSettingOutput> {
    const documentId = snapshot.params.documentId;

    if (!documentId) {
      throw ownedError(new Error('Document id is missing'));
    }

    return this.documentService.getDocumentSetting(documentId);
  }
}
